import { useCredentialingTranslation } from '../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
const Label = ({ value }) => {
    return (React.createElement(Typography, { variant: 'overline', fontWeight: 400, color: themeColors.text.main, fontSize: '12px' }, value.toUpperCase()));
};
export const TrainCoursesTable = ({ children }) => {
    const { t } = useCredentialingTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, px: 2, gap: 1 },
            React.createElement(Grid, { size: 4 },
                React.createElement(Label, { value: t('trainCourses.labels.name') })),
            React.createElement(Grid, { size: 2 },
                React.createElement(Label, { value: t('trainCourses.labels.completionDate') })),
            React.createElement(Grid, { size: 2 },
                React.createElement(Label, { value: t('trainCourses.labels.courseNumber') })),
            React.createElement(Grid, { size: 2 },
                React.createElement(Label, { value: t('trainCourses.labels.verificationStatus') }))),
        React.createElement(Stack, { mt: 2, direction: 'column', spacing: 2 }, children)));
};
export const TrainCoursesTableRow = ({ courseName, courseDate, courseNumber, verificationStatus }) => {
    return (React.createElement(Box, { sx: { bgcolor: themeColors.surface.secondary, borderRadius: '4px' } },
        React.createElement(Grid, { container: true, p: 2, gap: 1 },
            React.createElement(Grid, { size: 4 },
                React.createElement(Typography, { fontWeight: '500', fontSize: '14px' }, courseName)),
            React.createElement(Grid, { size: 2 },
                React.createElement(Typography, { fontSize: '14px' }, courseDate)),
            React.createElement(Grid, { size: 2 },
                React.createElement(Typography, { fontSize: '14px' }, courseNumber)),
            React.createElement(Grid, { size: 2 },
                React.createElement(VerificationStatusIcon, { status: verificationStatus })))));
};
const VerificationStatusIcon = ({ status }) => {
    const { t } = useCredentialingTranslation();
    switch (status) {
        case 'success':
            return (React.createElement(Stack, { direction: 'row', gap: 1, alignItems: 'center' },
                React.createElement(CheckCircleIcon, { htmlColor: themeColors.accent.green.bold }),
                React.createElement(Typography, { fontWeight: '500', color: themeColors.accent.green.bold, fontSize: '16px' }, t('trainCourses.verificationStatuses.success'))));
        default:
            return null;
    }
};
